import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Administrateur systèmes et réseaux",
          "Consultant systèmes et réseaux",
          "Responsable infrastructure systèmes et réseaux",
          "Ingénieur systèmes et réseaux",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
